import React from 'react';

const SatScoreField = ({
  name,
  label,
  value = "",
  onChange,
  required = false
}) => {
  const generateSATScoreOptions = () => {
    const options = [];
    for (let score = 400; score <= 1600; score += 10) {
      options.push(
        <option key={score} value={score}>
          {score}
        </option>
      );
    }
    return options;
  };

  const selectId = name;

  return (
    <div>
      <label htmlFor={selectId}>
        {label}
      </label>
      <select
        id={selectId}
        className="field"
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        aria-label={label}
      >
        <option value="" disabled>
          Select a SAT score
        </option>
        {generateSATScoreOptions()}
      </select>
    </div>
  );
};

export default SatScoreField;
